import EventAdminUsersViewApp from "./EventAdminUsersViewApp.vue";
import { vueApp } from "../Common/vueApp";

export default vueApp(EventAdminUsersViewApp);
